<div id="banner-motoreto" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-7">
                <div class="portada-title-linea">
                    <p class="p-display-bold primary-900 mb-3">
                        <span id="banner-motoreto-pretitle" class="border-y-1 border-primary-900" bannerStatus [bannerStatusConfig]="bannerConfig">NUEVA OPORTUNIDAD</span>
                    </p>
                    <h1 class="h1-display mb-2 primary-900">El SaaS que está revolucionando la <br class="d-none d-md-block d-xxl-none">industria del automóvil </h1>
                </div>
                <div class="d-none d-lg-block">
                    <p class="p-display primary-900">
                        SEGO Venture presenta <span class="p-display-bold">Motoreto</span>, la solución tecnológica que
                        genera<br class="d-none d-xxl-block"> más de 28M€ de ingresos, <br class="d-xl-none"> 700 clientes y ventas <br class="d-none d-xl-block d-xxl-none"> en 12 países.
                    </p>
                </div>
            </div>

            <div class="mt-3 mt-lg-4">
                <app-btn-click [btnId]="'btn-motoreto'" [btnTitle]="'¡Descúbrelo ahora!'" [btnStyle]="'secondary'"
                    (isBtnClicked)="enviarEventoClick()"></app-btn-click>
            </div>
        </div>
    </div>
</div>